import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "icon icon-close",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  width: "16",
  height: "16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M15.5,13.24l-2.3,2.24-5.19-5.19L2.79,15.48,.5,13.24l5.13-5.23L.55,2.76,2.75,.52l5.27,5.12L13.2,.52l2.27,2.18-5.08,5.31,5.12,5.23Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}